import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Flex,
  FlexItem
} from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { notifyParent } from 'mailup-react-helpers'

import useMessageSendAction from 'Hooks/useMessageSendAction'

import { saveMessageCallback } from '../recoil/callbacks/callbacks'
import { canSaveState, messageState } from '../recoil/state/message'

const Footer = () => {
  const intl = useIntl()

  const canSave = useRecoilValue(canSaveState)
  const { id, canSend, canQuickSend } = useRecoilValue(messageState)
  const save = useRecoilCallback(saveMessageCallback, [])

  const handleSendClick = useMessageSendAction(id)

  const handleQuickSendClick = useCallback(() => {
    notifyParent('quickSendMessage', [id])
  }, [id])

  const handleSaveClick = e => {
    save()
  }

  return (
    <Flex margin='0 0 24px 0' justifyContent='flex-end' columnGap='8px'>
      {canQuickSend && (
        <FlexItem>
          <Button
            data-mu-test='quick-send'
            kind={BUTTON_VARIANT_SECONDARY}
            onClick={handleQuickSendClick}
          >
            {intl.formatMessage({ id: 'Load.SavedEmailWizard.LabelQuickSend' })}
          </Button>
        </FlexItem>
      )}
      {canSend && (
        <FlexItem>
          <Button
            data-mu-test='send'
            kind={BUTTON_VARIANT_SECONDARY}
            onClick={handleSendClick}
          >
            {intl.formatMessage({ id: 'Load.SavedEmailWizard.LabelSend' })}
          </Button>
        </FlexItem>
      )}
      <Button
        data-mu-test='save'
        kind={BUTTON_VARIANT_PRIMARY}
        disabled={!canSave}
        onClick={handleSaveClick}
      >
        {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
      </Button>
    </Flex>
  )
}

export default Footer
